import { stringify } from 'qs';
import request from '../../../../../services/request';
import { url } from '../service-utils';

/**
 * 删除企业微信家长
 * 页面：异常处理页
 * 接口：陈新
 * 前端：谢小平
 */
export async function deleteParent(params) {
  return request(`${url.tool}/external/sync/delete-parent?${stringify(params)}`);
}
